import React, { useState } from "react";
import { PartnerFormShell, Row, Field, Pill } from "./PartnerFormShell";
import { Truck, Scissors, Timer } from "lucide-react";

const SERVICES = [
  "Die-cutting", "Lamination", "Pouching", "Binding",
  "Labelling", "Shrink-wrapping", "Palletising", "Last-mile delivery",
];
const SLAS = [
  { code: "same_day",  label: "Same-day" },
  { code: "next_day",  label: "Next-day" },
  { code: "two_three", label: "2–3 days" },
  { code: "flexible",  label: "Flexible" },
];

export default function PartnerLogistics() {
  const [extra, setExtra] = useState({
    services: [], sla: "next_day",
    serviceable_pincodes: "", pricing_per_unit: "",
    capacity_desc: "", pan_india: false,
  });
  const toggleSvc = (s) => setExtra(e => ({
    ...e,
    services: e.services.includes(s) ? e.services.filter(x => x !== s) : [...e.services, s],
  }));
  const setField = (e) => {
    const { name, value, type, checked } = e.target;
    setExtra(x => ({ ...x, [name]: type === "checkbox" ? checked : value }));
  };

  return (
    <PartnerFormShell
      partnerType="logistics"
      testIdPrefix="partner-logistics"
      accentHue="#F59E0B"
      title="Join as a Logistics / Finishing Partner"
      lede="Die-cutting, lamination, pouching, binding, last-mile — slot in on specific orders where a Buyer needs your service to complete the job. We route by service type and serviceable pincode."
      benefits={[
        { icon: <Scissors size={16}/>, title: "Order-specific jobs", body: "You're added onto a real job in the Dispatch Modal — no vague leads." },
        { icon: <Timer size={16}/>,    title: "SLA-matched",         body: "Buyers see partners by SLA band; same-day capability stays on top." },
        { icon: <Truck size={16}/>,    title: "Pay-per-use",         body: "No listing fees. Earn per completed service with transparent pricing." },
      ]}
      extraState={extra}
      validateExtra={() => extra.services.length === 0 ? "Please tick at least one service." : null}
      extraFields={
        <>
          <div className="pf-group">
            <label className="pf-label">Services you offer *</label>
            <div className="pf-pillrow">
              {SERVICES.map(s => (
                <Pill key={s} label={s}
                      active={extra.services.includes(s)}
                      onClick={() => toggleSvc(s)}
                      testid={`partner-logistics-svc-${s.replace(/\s/g,'-').toLowerCase()}`}/>
              ))}
            </div>
          </div>
          <Row>
            <label className="pf-field">
              <span>Typical SLA</span>
              <select name="sla" value={extra.sla} onChange={setField}
                      data-testid="partner-logistics-sla">
                {SLAS.map(s => <option key={s.code} value={s.code}>{s.label}</option>)}
              </select>
            </label>
            <Field label="Capacity (short description)" name="capacity_desc"
                   value={extra.capacity_desc} onChange={setField}
                   placeholder="e.g. 50,000 cartons/day die-cut, 2 shifts"
                   maxLength={160} testid="partner-logistics-capacity"/>
          </Row>
          <Row>
            <Field label="Serviceable pincodes (comma-separated)" name="serviceable_pincodes"
                   value={extra.serviceable_pincodes} onChange={setField}
                   placeholder="411001, 400001, 110001" maxLength={300}
                   testid="partner-logistics-pincodes"/>
            <Field label="Pricing per unit (indicative)" name="pricing_per_unit"
                   value={extra.pricing_per_unit} onChange={setField}
                   placeholder="e.g. ₹0.80 per carton die-cut; ₹3/sq ft lamination"
                   maxLength={160} testid="partner-logistics-pricing"/>
          </Row>
          <label className="pf-check" style={{marginTop:12}}>
            <input type="checkbox" name="pan_india"
                   checked={extra.pan_india} onChange={setField}
                   data-testid="partner-logistics-panindia"/>
            <span>We can arrange last-mile pan-India via our courier tie-ups</span>
          </label>
        </>
      }
    />
  );
}
